import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

import history from '../../utils/History.js'

class NavMenu extends React.Component {

	constructor(props) {
		super(props);

		this.onLinkClick = this.onLinkClick.bind(this);
		this.retrieveMenuItems = this.retrieveMenuItems.bind(this);

		this.state = {
			isOpen: false
		};
	}

	onLinkClick = (event, element) => {
		console.log("onLinkClick");
		event.preventDefault();
		history.push(element.actionUrl);
	}

	retrieveMenuItems() {

		var menuItems = [{
			id: 0,
			name: this.props.translate('menu.home'),
			actionUrl: '/',
			icon: 'home'
		}];

		this.buildMenu(menuItems, this.props.menuItems)

		return menuItems;
	}

	buildMenu(menu, menuItems) {

		for (var i = 0; i < menuItems.length; i++) {
			var menuItem = menuItems[i];

			if (menuItem.isHomepage) {
				continue;
			}

			var subMenu = [];

			var newMenuItem = {
				id: menuItem.id,
				name: menuItem.name,
				actionUrl: '/action/' + menuItem.actionId,
				actionType: menuItem.actionType,
				subMenuItems: subMenu,
				isExpanded: false,
				icon: '',
				linkUrl: menuItem.linkUrl,
				linkTarget: menuItem.linkTarget
			}

			if (menuItem.subMenuItems !== undefined && menuItem.subMenuItems.length > 0) {
				this.buildMenu(subMenu, menuItem.subMenuItems);
				newMenuItem.isExpanded = true;
			}
			else {
				newMenuItem.isExpanded = false;
				newMenuItem.icon = 'powerbilogo';
			}
			menu.push(newMenuItem);
		}
	} 

	renderMenuItem(menuItem) {
		let navitem;
		if (menuItem.actionType == "menu") {
			navitem = <Nav.Link eventKey="disabled" disabled>{menuItem.name}</Nav.Link>
        } else if (menuItem.linkUrl === null || menuItem.linkTarget === "content-window") {
			navitem = <Nav.Link as={Link} to={menuItem.actionUrl}>{menuItem.name}</Nav.Link>;
		} else if (menuItem.linkTarget === "new-window") {
			navitem = <a href={menuItem.linkUrl} target="_blank" className="nav-link">{menuItem.name}</a>;
		} else if (menuItem.linkTarget === "this-window") {
			navitem = <a href={menuItem.linkUrl} target="_self" className="nav-link">{menuItem.name}</a>;
		}
		return (
		<Nav.Item key={menuItem.id}>

				{navitem}

			{ menuItem.subMenuItems !== undefined && menuItem.subMenuItems.length > 0 &&
				<Nav>
				{
					menuItem.subMenuItems.map(j => {
						return this.renderMenuItem(j);
					})
				}
				</Nav>
			}

		</Nav.Item>);
	}


	render() {
		let menuItems = this.retrieveMenuItems();

		return (<Nav className="sidebar navbar-nav navbar-light bg-lightgrey SidebarMenu" >
			{menuItems.map(i => {
				return this.renderMenuItem(i);
			})}
		</Nav>);
	}
}

const mapStateToProps = state => ({
	...state.navigation,
	translate: getTranslate(state.localize)
});

export default connect(mapStateToProps, dispatch => bindActionCreators({}, dispatch))(NavMenu);



// WEBPACK FOOTER //
// ./src/components/Layout/NavMenu.js